// packages/web/src/constants/service.ts
// Constants for service components

export const WATERMARK_OPACITY = 0.08;